import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Container, Paper, TextField, Button, Typography,
    Box, Grid, Alert
} from '@mui/material';
import api from '../services/api';

function AdvogadoForm() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        nome: '',
        oab: '',
        email: '',
        telefone: ''
    });

    useEffect(() => {
        if (id) {
            loadAdvogado();
        }
    }, [id]);

    const loadAdvogado = async () => {
        try {
            const response = await api.get(`/advogados/${id}`);
            setFormData(response.data);
        } catch (error) {
            console.error('Erro ao carregar advogado:', error);
            setError('Erro ao carregar dados do advogado');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!formData.nome) {
            setError('Nome é obrigatório');
            return;
        }

        try {
            if (id) {
                await api.put(`/advogados/${id}`, formData);
            } else {
                await api.post('/advogados', formData);
            }
            navigate('/advogados');
        } catch (error) {
            console.error('Erro ao salvar advogado:', error);
            setError(error.response?.data?.error || 'Erro ao salvar advogado');
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Container maxWidth="md">
            <Paper sx={{ p: 4, mt: 4 }}>
                <Typography variant="h5" gutterBottom>
                    {id ? 'Editar Advogado' : 'Novo Advogado'}
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <Box component="form" onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                required
                                fullWidth
                                label="Nome"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="OAB"
                                name="oab"
                                value={formData.oab}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Telefone"
                                name="telefone"
                                value={formData.telefone}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                        >
                            Salvar
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/advogados')}
                        >
                            Cancelar
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
}

export default AdvogadoForm;

